<template>	
	<vs-row>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" class="text-left">
			<Number v-model="questionsByPage[index].properties.size" :label="$t('MODULE.valueMaxRanking')"></Number>			
		</vs-col>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" class="text-left">
			<Color :index="index"></Color>
		</vs-col>		
	</vs-row>
	
</template>
<script type="text/javascript">
	import Number from '../../components/Number.vue';	
	import Color from '../../componentsToQuestions/Color.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Number, Color },
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
	
</script>